import Vue from "vue"

window._ = require('lodash');

try {
    window.$ = window.jQuery = require('jquery');

    window.Popper = require('popper.js').default;

    require('bootstrap');

    window.swal = require('sweetalert2');

    require('admin-lte');
    require('admin-lte/plugins/daterangepicker/daterangepicker.js');


} catch (e) {}


window.moment = require('moment');
// window.axios = require('axios');

import { BootstrapVue } from 'bootstrap-vue'

Vue.use(BootstrapVue)

import ApiService from "@/plugins/ApiService";

ApiService.init()


require('@/plugins/mixins/utils')
require('@/plugins/moment_filter')

require('@/plugins/vee-validate')
require('@/plugins/mixins/gate')

// import Multiselect from 'vue-multiselect'
// Vue.component('multiselect', Multiselect)


// import Datepicker from "vuejs-datepicker";
// Vue.component('datepicker', Datepicker);




import VueProgressBar from 'vue-progressbar'
Vue.use(VueProgressBar, {
    color: 'rgb(143, 255, 199)',
    failedColor: 'red',
    thickness: '8px',

})


Vue.prototype.$eventHub = new Vue();


Vue.filter('capitalize', function(value) {
    if (!value) return ''
    value = value.toString()
    return value.charAt(0).toUpperCase() + value.slice(1)
})


import Content from "@/components/common/Content"
Vue.component("main-content", Content);